import type { TextProps } from '@frontend/web-react';
import { Icon, Text, XStack, YStack } from '@frontend/web-react';
import type { IconName } from '@frontend/web-react/components/Primitives/Icon/helpers';
import type { ClassName } from '@frontend/web-utils';
import { concatClasses } from '@frontend/web-utils';

type CardContentProps = {
  captionAboveDescription?: string;
  captionBelowDescription?: string;
  containerClassName?: ClassName;
  description?: string;
  descriptionTextProps?: TextProps;
  iconList?: { icon: IconName; text: string }[];
};

export const CardContent = ({
  captionAboveDescription,
  captionBelowDescription,
  containerClassName,
  description,
  descriptionTextProps,
  iconList,
}: CardContentProps) => (
  <YStack className={concatClasses('gap-md', containerClassName)}>
    {captionAboveDescription ? (
      <Text color="tertiary" type="caption">
        {captionAboveDescription}
      </Text>
    ) : null}
    {iconList?.length ? (
      <YStack className="gap-xs">
        {iconList.map(({ icon, text }, index) => (
          <XStack className="gap-sm items-center" key={index}>
            <Icon name={icon} size="md" />
            <Text color="secondary" type="p-sm">
              {text}
            </Text>
          </XStack>
        ))}
      </YStack>
    ) : null}
    {description ? (
      <Text color="secondary" type="p-sm" {...descriptionTextProps}>
        {description}
      </Text>
    ) : null}
    {captionBelowDescription ? (
      <Text color="tertiary" type="caption">
        {captionBelowDescription}
      </Text>
    ) : null}
  </YStack>
);
